import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

/**
 * Redirect a user to the user dash or the team dash
 *
 * @param {*} param0
 */
const DashRedirectContainer = ({ isTeamAdmin, user, team, history }) => {
  useEffect(() => {
    if (isTeamAdmin === false) {
      history.replace(`/dash/user`);
      return;
    }

    if (isTeamAdmin && user) {
      const userTeamId = user.teams[0].team;

      if (
        team &&
        user.teams.findIndex(userTeam => userTeam.team === team._id) !== -1
      ) {
        history.replace(`/dash/team/${team._id}`);
        return;
      }

      history.replace(`/dash/team/${userTeamId}`);
    }
  }, [history, isTeamAdmin, user, team]);

  return <span />;
};

DashRedirectContainer.propTypes = {
  isTeamAdmin: PropTypes.bool,
  user: PropTypes.object,
  team: PropTypes.object,
  history: PropTypes.object
};

export default withRouter(
  connect(state => {
    const { isTeamAdmin, user, team } = state;

    return { isTeamAdmin, user, team };
  }, {})(DashRedirectContainer)
);
